module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/orange-grove@2x_bf7ab5.jpg";